import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { findPerformanceBandIndex } from 'switch-fe-shared/components/Charts/recharts/utils/performanceBands';

import {
  formatPercent,
  getSolarPerformanceBands,
} from '../../utils/solarPresentation';

interface Props {
  ratio: number;

  /** @default 0 */
  decimals?: number;
}

/** A performance percentage led by a dot in its performance band's colour. */
const SolarPerformanceValue = ({ ratio, decimals = 0 }: Props) => {
  const theme = useTheme();
  const bands = getSolarPerformanceBands(theme);
  const band = bands[findPerformanceBandIndex(ratio, bands) ?? 0];

  return (
    <Box component='span' display='inline-flex' alignItems='center' gap={0.75}>
      <Box
        component='span'
        sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          bgcolor: band.color,
          flexShrink: 0,
        }}
      />
      {formatPercent(ratio, decimals)}
    </Box>
  );
};

export default SolarPerformanceValue;
